import React from 'react';
import './Skeleton.css';

const Skeleton = ({ type = 'text', width, height, className, count = 1 }) => {
  const elements = [];

  for (let i = 0; i < count; i++) {
    elements.push(
      <div
        key={i}
        className={`skeleton skeleton-${type} ${className || ''}`}
        style={{ width, height }}
      />
    );
  }

  return <>{elements}</>;
};

// Componentes específicos de skeleton
export const SkeletonCard = ({ count = 1 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="skeleton-card">
        <Skeleton type="circle" width="56px" height="56px" />
        <div className="skeleton-card-content">
          <Skeleton type="text" width="60%" height="16px" />
          <Skeleton type="text" width="40%" height="24px" />
        </div>
      </div>
    ))}
  </>
);

export const SkeletonTable = ({ rows = 5, columns = 6 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {Array.from({ length: columns }).map((_, i) => (
        <Skeleton key={i} type="text" width="100%" height="20px" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <Skeleton key={colIndex} type="text" width="100%" height="16px" />
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonForm = ({ fields = 3 }) => (
  <div className="skeleton-form">
    {Array.from({ length: fields }).map((_, i) => (
      <div key={i} className="skeleton-form-field">
        <Skeleton type="text" width="30%" height="16px" />
        <Skeleton type="rect" width="100%" height="40px" />
      </div>
    ))}
  </div>
);

export const SkeletonList = ({ items = 5 }) => (
  <div className="skeleton-list">
    {Array.from({ length: items }).map((_, i) => (
      <div key={i} className="skeleton-list-item">
        <Skeleton type="circle" width="40px" height="40px" />
        <div className="skeleton-list-content">
          <Skeleton type="text" width="70%" height="16px" />
          <Skeleton type="text" width="50%" height="14px" />
        </div>
      </div>
    ))}
  </div>
);

export default Skeleton;

